import { GetSymbolListQuery } from 'views/utils/graphql/graphql';
import { ProductInfoProps } from '../../home/hooks';
import { ListProductCard } from 'views/components/molecules/product';
import { operationDatePlanCalc } from 'views/utils/calc/operationDatePlan';
import { formatThousand } from 'views/utils/calc/formatThousand';

export const createListProductCard = (data: GetSymbolListQuery) => {
  if (!data.GetSymbolList?.Data) return [];
  const list = data.GetSymbolList?.Data?.map((symbol) => {
    const param: ProductInfoProps = {
      to: `/productDetail/${symbol?.Symbol}`,
      image: symbol?.ImageUrl || '',
      title: symbol?.SymbolName || '',
      TradeStartDate: symbol?.TradeStartDate || '',
      TradeEndDate: symbol?.TradeEndDate || '',
      description: symbol?.Overview || '',
      tradable: symbol?.Tradable || false,
      details: [
        {
          title: '一口',
          item: formatThousand(symbol?.PricePerUnit || 0) || '',
          frontUnit: '',
          rearUnit: '万円',
        },
        {
          title: '予想分配率',
          item: symbol?.ExpectedInterestRate.toString() || '',
          frontUnit: '年',
          rearUnit: '%',
        },
        {
          title: '予定運用期間',
          item: operationDatePlanCalc(symbol?.OperationStartDate || '', symbol?.OperationEndDate || ''),
          frontUnit: '約',
          rearUnit: '',
        },
      ],
    };
    return param;
  });

  const data2 = list?.map((param, index) => {
    return <ListProductCard {...param} key={index} />;
  });

  return data2;
};
